import { Service } from "../interface/service";
import {Observable} from "rxjs/internal/Observable";
let debounce = require('lodash.debounce');

const scroll_offset: number = 130;

export class ScrollService implements Service {

    protected current: string;
    protected delta: number = 5;

    public static getScrollTop = () => $(window).scrollTop();

     public static observeScroll = () =>
        new Observable(observer =>
            <any>$(window).on('scroll', debounce(() => observer.next(ScrollService.getScrollTop()))));

    public static scrollTo = (hash:string, container?:JQuery<any>, additionalOffset:number = 0) => {
        let $hash = $(hash);
        if ($hash.length !== 0) {
            let $container = container ? $(container) : $('html, body');
            $container.animate({
                scrollTop: $hash.offset().top - (scroll_offset + additionalOffset)
            }, 800, function () {
                window.location.hash = hash;
            });
        }
    }

    public static scrollToPoint = (top:number, container?:JQuery<any>) => {
        let $container = container ? $(container) : $('html, body');
        $container.animate({
            scrollTop: top
        }, 800);
    }

}
